// extracted by mini-css-extract-plugin
module.exports = {"hidden":"Counter_hidden__knzhV","livesNow":"Counter_livesNow__LFzTx"};